import { get } from 'lodash';

export const getAgreement = (state, { idagreementtype }) => get(state, `agreements.${idagreementtype}`);
export const isAgreementLoading = (state, { idagreementtype }) => get(state, `agreements.${idagreementtype}.loading`) || false;
